import React from "react";
import App from "../../app/App";
import PasswordChange from "./PasswordChange";

export default () => (
  <App>
    <PasswordChange />
  </App>
);
